import * as z from "zod";

export const connectMiraklMarketplace = {
  name: "connectMiraklMarketplace" as const,
  input: z.object({
    connectionId: z.string().min(1),
    apiKey: z.string().trim().min(1),
  }),
  output: z.discriminatedUnion("success", [
    z.object({ success: z.literal(true) }),
    z.object({
      success: z.literal(false),
      reason: z.enum([
        "invalid_key",
        "missing_scope",
        "unreachable",
        "unknown_marketplace",
      ]),
    }),
  ]),
};
